<template>
    <div class="select-entity">
        <a-button class="select-entity-btn" @click="showModal" v-show="multiple || entityList.length == 0" ><a-icon type="select"/>{{btnText}}</a-button>
        <ul class="entity-list" v-show="entityList && entityList.length > 0">
            <li class="entity-item" v-for="(item, i) in entityList" :key="item.id">
                <slot name="item" v-bind:item="item" v-if="$scopedSlots.item"></slot>
                <div class="entity-name" v-else>{{item[nameKey]}}</div>
                <a-icon type="delete" style="cursor: pointer" @click="removeSelect(i)"/>
            </li>
        </ul>
        <a-modal
            :title="btnText"
            :maskClosable="false"
            :closable="false"
            :destroyOnClose="true"
            :width="modalWidth"
            @ok="confirmSelect"
            v-model="visible">
            <data-list
                hide-action
                :height="500"
                :url="url"
                :search-key-type="searchKeyType"
                :row-selection="{type: multiple ? 'checkbox' : 'radio', selectedRowKeys: selectKeys}"
                :columns="columns"
                :query="query"
                @rowClick="handleRowClick"
                v-if="url">
                <template v-slot:query="{form}">
                    <a-form-model-item label="">
                        <a-input v-model="form.name" placeholder="输入姓名/名称查询"/>
                    </a-form-model-item>
                </template>
            </data-list>
        </a-modal>
    </div>
</template>

<script>
    import {clone, isArray} from "../../common/js/tool";

    export default {
        name: "select-entity",
        model: {
            event: 'change'
        },
        props: {
            btnText: {
                type: String,
                default: '点击选择'
            },
            url: String,
            query: String,
            value: [Array, Object],
            columns: Array,
            nameKey: {
                type: String,
                default: 'name'
            },
            modalWidth: {
                type: Number,
                default: 600
            },
            multiple: Boolean
        },
        data() {
            return {
                visible: false,
                entity: null,
                selectKeys: [],
                selectItems: [],
                entityList: []
            }
        },
        computed: {
            searchKeyType() {
                const res = {};
                const nameKey = this.nameKey;
                res[nameKey] = 1;
                return res;
            }
        },
        created() {
            this.setEntityList()
        },
        watch: {
            value() {
                this.setEntityList();
            }
        },
        methods: {
            setEntityList() {
                let value = this.value;
                if(value) {
                    if(isArray(value)) {
                        this.entityList = this.value;
                    } else {
                        this.entityList = [this.value]
                    }
                } else {
                    this.entityList = [];
                }
            },
            removeSelect(index) {
                this.entityList.splice(index, 1);
                this.dispatchInput();
            },
            showModal() {
                let list = this.entityList;
                let keys = list.map(item => item.id);
                this.selectKeys = keys;
                this.selectItems = clone(list)
                this.visible = true;
            },
            handleRowClick({item}) {
                let keys = this.selectKeys;
                if(this.multiple) {
                    let index = keys.indexOf(item.id);
                    if(index >= 0) {
                        this.selectKeys.splice(index, 1);
                        this.selectItems.splice(index, 1);
                    } else {
                        this.selectKeys.push(item.id);
                        this.selectItems.push(item);
                    }
                } else {
                    if(keys.length > 0 && keys[0] == item.id) {
                        this.selectKeys = [];
                        this.selectItems = [];
                    } else {
                        this.selectKeys = [item.id];
                        this.selectItems = [item];
                    }
                }
            },
            hideModal() {
                this.selectKeys = [];
                this.selectItems = [];
                this.visible = false;
            },
            dispatchInput(list) {
                list = list || this.entityList;
                this.$emit('change', list.length > 1 ? list : list[0]);
            },
            confirmSelect() {
                if(this.selectItems.length > 0) {
                    this.entityList = this.selectItems;
                    this.dispatchInput(this.entityList);
                }
                this.hideModal();
            }
        }
    }
</script>

<style scoped lang="less">
    .select-entity-btn {
        margin: 4px 0 @padding-sm;
    }
    .entity-item {
        display: flex;
        align-items: center;
        padding: @padding-xs;
        min-width: 240px;
        border: var(--border);
        border-radius: @border-radius-base;
        &:not(:first-of-type) {
            margin-top: @padding-xs;
        }
    }
    .entity-name {
        flex: 1;
        margin-right: @padding-sm;
        line-height: 1.5;
    }
</style>
